import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(serviceWorkerActivationListener);

import { call, put, take } from 'redux-saga/effects';
import { serviceWorkerAwaitingActivation, acceptServiceWorkerUpdate, dismissServiceWorkerUpdate } from './actions';
/**
 * Called when an updated service worker is available. Dispatches an action that
 * informs the user there is an update available, and then waits for their
 * decision to accept or dismiss the update (falling back to default behavior).
 */

export function serviceWorkerActivationListener(activateCallback) {
  var action, isAccepted;
  return _regeneratorRuntime.wrap(function serviceWorkerActivationListener$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(serviceWorkerAwaitingActivation());

        case 2:
          _context.next = 4;
          return take([acceptServiceWorkerUpdate, dismissServiceWorkerUpdate]);

        case 4:
          action = _context.sent;
          isAccepted = action && action.type === acceptServiceWorkerUpdate.getType(); // callback is called with user's decision to activate or not

          _context.next = 8;
          return call(activateCallback, isAccepted);

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}